export const toggleDOMClass = ({ selector, className, type }) => () => {
  const selectedElement = document.querySelectorAll(selector)[0];
  switch (type) {
    case 'add':
      selectedElement.classList.add(className);
      break;
    case 'remove':
      selectedElement.classList.remove(className);
      break;
    default:
      break;
  }
};
